import { render, staticRenderFns } from "./open-bill-alert.vue?vue&type=template&id=458c3ace&scoped=true&"
import script from "./open-bill-alert.vue?vue&type=script&lang=js&"
export * from "./open-bill-alert.vue?vue&type=script&lang=js&"
import style0 from "./open-bill-alert.vue?vue&type=style&index=0&id=458c3ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458c3ace",
  null
  
)

export default component.exports